export interface CompanyAdmin {
  id: number
  name: string
  active?: boolean
}

export interface Company {
  id: number
  name: string
  active: boolean
  cga?: {
    id: number
    name?: string
  }
}

export interface Vessel {
  id: number
  fleet_name: string
  imoNumber: string
  vesselType: string
  companyAdmin?: { id: number }
  companyGroupAdmin?: { id: number }
  active?: boolean
}

export interface Template {
  id: number
  name: string
  description?: string
  formType?: string
  isActive?: boolean
  companyGroupAdminId?: number
  companyAdminId?: number
}

export interface Reports {
  id: number
  name: string
  order: number
  templateId: number
  isActive: boolean
  submenus: Submenu[]
  customTemplateId?: number
}

export interface Submenu {
  id: number
  name: string
  isActive: boolean
  fields: Fields[]
  menuId: number
  order?: number
}

export interface Fields {
  id: number
  label: string
  fieldType: string
  readOnly: boolean
  isActive: boolean
  order?: number
  optionsJson?: string[]
  value?: string | number | string[]
  required: boolean
  unit?: string
  minValue?: number
  maxValue?: number
  warningOnly?: WarningLevel
  submenuId: number
}

export enum WarningLevel {
  STRICT = 'STRICT',
  SOFT = 'SOFT',
}

// Present in the layout as a legacy hook for assignments; QHSE library does not use it today.
export interface AssignedReports {
  id: number
  template?: {
    id: number
    name?: string
  } | null
  customTemplate?: {
    id: number
    masterTemplateId?: number
    menus?: Array<{
      id: number
      name: string
      isActive: boolean
      submenus?: Submenu[]
    }>
  } | null
}

